import React from 'react'
import PropTypes from 'prop-types'
import MessageReportSubscription from './MessageReportSubscription'
import ContactInfoMap from './ContactInfoMap'
import css from './location.css'

const Location = ({
  data: {
    address: { street_address: streetAddress, city, state, zip },
    id,
    forwarding_email: forwardingEmail,
    name,
    office_email: officeEmail,
    office_phone: officePhone,
    online_scheduling_email: onlineSchedulingEmail,
    phone_numbers: phoneNumbers,
  },
  hasDSO,
  hasReminders,
}) => (
  <div className={css.wrapper}>
    <div className={css.nameAddress}>
      <h3 className={css.name}>{name}</h3>
      <div className={css.addressOsEmail}>
        <div className={css.address}>
          <span>{streetAddress}</span>
          <br />
          <span>
            {city}, {state} {zip}
          </span>
        </div>
        <div className={css.osEmail}>
          {onlineSchedulingEmail && (
            <div>
              <span>Email for OS Notifications</span>
              <br />
              <span className={css.osEmailText}>{onlineSchedulingEmail}</span>
            </div>
          )}
        </div>
      </div>
    </div>
    <div className={css.contactInfo}>
      <div className={css.headers}>
        <span className={css.col1}>Forwarding Contact</span>
        <span className={css.col3}>Office Contact</span>
      </div>
      <ContactInfoMap
        forwardingInfo={phoneNumbers.join(', ')}
        officeInfo={officePhone}
      />
      <ContactInfoMap
        forwardingInfo={forwardingEmail}
        officeInfo={officeEmail}
      />
    </div>
    {hasDSO && hasReminders && (
      <div className={css.messageReportSubscription}>
        <MessageReportSubscription locationId={id} locationName={name} />
      </div>
    )}
  </div>
)

Location.propTypes = {
  data: PropTypes.shape({
    address: PropTypes.shape({
      street_address: PropTypes.string.isRequired,
      city: PropTypes.string.isRequired,
      state: PropTypes.string.isRequired,
      zip: PropTypes.string.isRequired,
    }).isRequired,
    forwarding_email: PropTypes.string,
    id: PropTypes.string.isRequired,
    office_email: PropTypes.string,
    office_phone: PropTypes.string,
    online_scheduling_email: PropTypes.string,
    phone_numbers: PropTypes.arrayOf(PropTypes.string),
  }),
  hasDSO: PropTypes.bool.isRequired,
  hasReminders: PropTypes.bool.isRequired,
}

export default Location



// WEBPACK FOOTER //
// ./src/components/Account/Location.js